import { Component, inject } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { Role } from "@app/role";
import { UiKitModule } from "@app/ui-kit.module";
import type { ScopedProject } from "@domain/project/project-guards";
import { ProjectService } from "@domain/project/project.service";
import { Modal, ModalRef } from "@odx/angular/components/modal";
import { filter } from "rxjs";
import { take } from "rxjs/operators";

@Component({
  selector: "app-confirm-delete-project-modal",
  templateUrl: "./confirm-delete-project-modal.component.html",
  styleUrls: ["./confirm-delete-project-modal.component.scss"],
  imports: [UiKitModule, ReactiveFormsModule],
})
export class ConfirmDeleteProjectModalComponent implements Modal<any, boolean> {
  private projectService = inject(ProjectService);

  public readonly modalRef = inject(ModalRef<any, string>);
  protected readonly navigator = navigator;
  protected project: ScopedProject = this.modalRef.data.project;

  formGroup = new FormGroup({
    confirmationCheckbox: new FormControl({
      value: false,
      disabled: true,
    }),
  });

  constructor() {
    if (this.project.cloudId && navigator.onLine) {
      this.projectService
        .getUserRoleInProject(this.project.cloudId)
        .pipe(
          take(1),
          filter((userData) => userData.assignedRole === Role.OWNER),
        )
        .subscribe(() => this.formGroup.controls.confirmationCheckbox.enable());
    }
  }

  get offlineToolTipMessage() {
    return this.canBeRemovedFromCloud()
      ? $localize`:@@project.remove.fromCloud:Diese Funktion ist nur im Online-Modus verfügbar und ausschließlich dem Projekteigentümer vorbehalten.`
      : "";
  }

  onConfirm() {
    this.modalRef.close(this.formGroup.controls.confirmationCheckbox.value);
  }

  private canBeRemovedFromCloud() {
    return this.formGroup.controls.confirmationCheckbox.disabled;
  }
}
